import React from 'react';
import styled from 'styled-components';
import { lighten } from 'polished';
import MuiStarIcon from '@material-ui/icons/Stars';
import colors from 'theme/colors';
import FxLogo from 'assets/svg/FxLogo';

const { primary } = colors;

const colorGradientHigh = 0.3;

const Container = styled.div`
  align-items: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  display: flex;
  font-size: 14px;
  justify-content: flex-start;
  line-height: 16px;
  list-style: none;
  padding: 8px 16px 8px 8px;
  text-align: left;

  &:hover {
    background-color: ${lighten(colorGradientHigh, primary)};
    color: ${primary};
    cursor: pointer;
  }
`;

const Description = styled.div``;

const FavoriteIconContainer = styled.div`
  min-width: 24px;
  svg {
    fill: ${primary};
    width: 16px;
  }
`;

const FormulaIconContainer = styled.div`
  margin-right: 5px;
`;

export default ({
  onClick,
  description,
  isFavorite,
  types,
}: {
  onClick: () => void;
  description: string;
  isFavorite?: boolean;
  types?: string;
}) => {
  return (
    <>
      {description && (
        <Container data-testid="tid-marker-search-result-item" onClick={onClick}>
          <FavoriteIconContainer>{isFavorite && <MuiStarIcon />}</FavoriteIconContainer>
          <FormulaIconContainer>{types === 'custom' && <FxLogo />}</FormulaIconContainer>
          <Description>{description}</Description>
        </Container>
      )}
    </>
  );
};
